import { useContext } from 'react';
import { CollapseDrawerContext } from 'App/contexts/CollapseDrawerContext';

export const useCollapseDrawer = () => useContext(CollapseDrawerContext);
